// extracted by mini-css-extract-plugin
export default {"card":"Certificate_card__ORUs+","image":"Certificate_image__7rOWa","title":"Certificate_title__+GAC3"};